import { useTranslation } from 'libs/i18n';
import { Button, Stack } from 'libs/ui';
import { useDialog } from 'libs/ui/Dialog/useDialog';
import { Icon } from 'libs/ui/Icon';
import { Content, Title } from 'modules/account/common/components';

import {
  DialogCreateOrder,
  OrdersTable,
  OrdersTableProps,
} from '../../components';

import { ContentStackStyled } from './styles';

export interface OrdersViewProps extends OrdersTableProps {
  loading?: boolean;
}

export const OrdersView = ({ loading, ...tableProps }: OrdersViewProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, open } = useDialog();

  return (
    <Content>
      <ContentStackStyled spacing={32}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Title title={t('account.orders.title')} />
          <Button
            label={t('account.orders.createOrderLabel')}
            mode="standard-small"
            startIcon={<Icon.Plus size={20} />}
            onClick={open}
          />
        </Stack>
        <OrdersTable loading={loading} {...tableProps} />
      </ContentStackStyled>

      <DialogCreateOrder isOpen={isOpen} onClose={onClose} />
    </Content>
  );
};
